import { render, staticRenderFns } from "./rating-sri.vue?vue&type=template&id=43ee2d00&scoped=true&lang=pug"
import script from "./rating-sri.vue?vue&type=script&lang=ts"
export * from "./rating-sri.vue?vue&type=script&lang=ts"
import style0 from "./rating-sri.vue?vue&type=style&index=0&id=43ee2d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ee2d00",
  null
  
)

export default component.exports